import styled from 'styled-components';

export const Content = styled.div`
  .contracts-notice {
    background: ${(props) => props.theme.$gray100};
    color: ${(props) => props.theme.$gray700};

    .material-icons {
      font-size: 20px;
    }
  }

  .year-total {
    font-size: 16px;
    color: ${(props) => props.theme.$dark};
  }

  .contracts-table th,
  .contracts-table td {
    padding: 0.75rem;
    font-size: 13px;
    vertical-align: middle;
  }

  .contracts-table thead th {
    border-top: 0;
    white-space: nowrap;
  }

  .contract-cell {
    width: 100%;
    max-width: 0;
    min-width: 180px;
  }

  .contract-orgao {
    color: ${(props) => props.theme.$dark};
    font-weight: 500;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .contract-docs {
    min-width: 96px;
  }

  .btn-sm .material-icons {
    font-size: 18px;
    vertical-align: middle;
  }
`;
